import { __spreadArray } from 'tslib';
import * as React from 'react';
import { useRef, useEffect } from 'react';
import { UitkLineSkeleton } from 'uitk-react-skeleton';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-date-range.css';

var getClassNameList$1 = classNames.bind(styles);
var UitkDateRange = function (_a) {
    var loading = _a.loading, loadingMessage = _a.loadingMessage, results = _a.results;
    var baseClassName = 'uitk-date-range';
    var buttonClassName = baseClassName + "-button";
    var scrollMouse = { move: false, initialMousePos: 0, buttonLeft: 0 };
    var dateRangeRef = useRef(null);
    var getSelectedDateResultsIndex = function () { return results.findIndex(function (resultObj) { return resultObj.selected; }); };
    var selectedDateIndex = getSelectedDateResultsIndex();
    var applyFade = function (target) {
        var _a, _b, _c, _d, _e, _f, _g;
        var maxScrollLeft = target.scrollWidth - target.clientWidth;
        var targetAbsoluteScroll = Math.abs(target.scrollLeft);
        if (targetAbsoluteScroll >= maxScrollLeft - 10) {
            // @ts-ignore
            (_a = target.classList).add.apply(_a, ['unfade-end']);
            (_b = target.classList).remove.apply(_b, ['fade-end']);
        }
        else {
            (_c = target.classList).add.apply(_c, ['fade-end']);
            (_d = target.classList).remove.apply(_d, ['unfade-end']);
        }
        if (targetAbsoluteScroll <= 10) {
            (_e = target.classList).remove.apply(_e, ['fade-start']);
            (_f = target.classList).remove.apply(_f, ['fade-end']);
        }
        else {
            (_g = target.classList).add.apply(_g, ['fade-start']);
        }
    };
    var buttonScroll = function (parent) {
        if (parent.currentTarget) {
            applyFade(parent.currentTarget);
        }
    };
    var resizeTimeout;
    var mouseDown = function (ev) {
        scrollMouse.move = true;
        scrollMouse.initialMousePos = ev.clientX;
        scrollMouse.buttonLeft = ev.currentTarget.scrollLeft;
    };
    var mouseUp = function () {
        scrollMouse.move = false;
    };
    var mouseMove = function (ev) {
        if (scrollMouse.move) {
            // eslint-disable-next-line no-param-reassign
            ev.currentTarget.scrollLeft = scrollMouse.buttonLeft + scrollMouse.initialMousePos - ev.clientX;
            buttonScroll(ev);
        }
    };
    var onWindowResize = function () {
        if (!resizeTimeout) {
            resizeTimeout = setTimeout(function () {
                resizeTimeout = null;
                applyFade(dateRangeRef.current);
            }, 200);
        }
    };
    useEffect(function () {
        var dateRangeEl = dateRangeRef && dateRangeRef.current;
        var selectedDateScrollCenterDistance = UitkDateRangeGetSelectedDateScrollCenterDistance(dateRangeEl, selectedDateIndex);
        dateRangeEl && (dateRangeEl.scrollLeft = selectedDateScrollCenterDistance);
        applyFade(dateRangeRef.current);
        window.addEventListener('resize', onWindowResize);
        return function () {
            window.removeEventListener('resize', onWindowResize);
        };
    }, []);
    return (React.createElement("div", { className: getClassNameList$1(baseClassName + "-container") },
        loading && loadingMessage && React.createElement("span", { className: "is-visually-hidden" }, loadingMessage),
        React.createElement("ul", { ref: dateRangeRef, role: "tablist", className: getClassNameList$1(baseClassName), onScroll: buttonScroll, onMouseDown: mouseDown, onMouseUp: mouseUp, onMouseMove: mouseMove, onMouseLeave: mouseUp },
            !loading &&
                results.map(function (result, index) {
                    var buttonName = buttonClassName + "-" + index;
                    return (React.createElement("li", { className: getClassNameList$1(baseClassName + "-button-wrapper-natural"), role: "presentation", key: buttonName },
                        React.createElement(UitkDateRangeButton, { className: getClassNameList$1(buttonClassName), result: result })));
                }),
            loading &&
                __spreadArray([], Array(7), true).map(function (_, index) { return (React.createElement("li", { className: getClassNameList$1('uitk-date-range-loading-cell'), key: "uitk-date-range-loading-cell-" + index, role: "tab" },
                    React.createElement(UitkLineSkeleton, null))); }))));
};

var getClassNameList = classNames.bind(styles);
var UitkDateRangeButton = function (_a) {
    var _b;
    var className = _a.className, result = _a.result;
    var accessibilityMessage = result.accessibilityMessage, analytics = result.analytics, dateText = result.dateText, onClickCallback = result.onClickCallback, _c = result.selected, selected = _c === void 0 ? false : _c, text = result.text, textTheme = result.textTheme;
    var onClickCapture = function () {
        analytics && analyticsTracker(analytics);
        onClickCallback && onClickCallback();
    };
    var buttonClassNames = getClassNameList(className, (_b = {},
        // eslint-disable-next-line no-useless-computed-key
        _b['selected'] = selected,
        _b["" + textTheme] = textTheme,
        _b));
    return (React.createElement("button", { type: "button", "aria-selected": selected, "aria-label": accessibilityMessage, className: buttonClassNames, onClickCapture: onClickCapture, role: "tab" },
        React.createElement("span", { className: getClassNameList(className + "-date-text") }, dateText),
        React.createElement("span", { className: getClassNameList(className + "-text") }, text)));
};

var UitkDateRangeGetCenterScrollDistance = function (selectedDateOffset, selectedDateWidth, dateRangeWidth) {
    return selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2 > 0
        ? selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2
        : 0;
};
var UitkDateRangeGetSelectedDateScrollCenterDistance = function (dateRangeEl, selectedDateIndex) {
    if (!dateRangeEl) {
        return 0;
    }
    var selectedDateEl = dateRangeEl.querySelectorAll('li')[selectedDateIndex];
    var dateRangePxWidth = dateRangeEl.offsetWidth;
    var selectedDatePxWidth = selectedDateEl && selectedDateEl.offsetWidth;
    var selectedDatePxOffset = selectedDateEl && selectedDateEl.offsetLeft;
    return UitkDateRangeGetCenterScrollDistance(selectedDatePxOffset, selectedDatePxWidth, dateRangePxWidth);
};

export { UitkDateRange, UitkDateRangeButton, UitkDateRangeGetCenterScrollDistance, UitkDateRangeGetSelectedDateScrollCenterDistance };
